import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowInput, FormikRowCheckbox} from "@components/panel/formik";

export enum TargetType {
    All = 'all',
    One = 'one'
}

export interface RefFormValues {
    name: string;
    description: string;
    isActive: boolean;
    hidden: boolean;
    order: number;
    targetType: TargetType;
}

interface RefBaseInfoBlockProps {
    editForm?: boolean;
}

const RefBaseInfoBlock: FC<RefBaseInfoBlockProps> = ({editForm}) => {
    const {values, setFieldValue, errors} = useFormikContext<RefFormValues>();

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Основное</Card.Header>
            <Card.Body>
                <Field
                    label="Название"
                    name="name"
                    component={FormikRowInput}
                />

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Описание</Form.Label>
                    <Col sm={9}>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={values.description}
                            onChange={e => setFieldValue('description', e.target.value)}
                            isInvalid={Boolean(errors.description)}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.description}
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Field
                    label="Скрыто"
                    name="hidden"
                    type="switch"
                    id="ref-hidden"
                    component={FormikRowCheckbox}
                />

                {editForm && (
                    <>
                        <Field
                            label="Активно"
                            name="isActive"
                            type="switch"
                            id="ref-active"
                            component={FormikRowCheckbox}
                        />

                        <Field
                            label="Порядковый номер"
                            name="order"
                            type="number"
                            component={FormikRowInput}
                        />

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Условия</Form.Label>
                            <Col sm={9}>
                                <Form.Check
                                    type="radio"
                                    name="targetType"
                                    id="target-one"
                                    label="Хотя бы одно"
                                    checked={values.targetType === TargetType.One}
                                    onChange={() => setFieldValue('targetType', TargetType.One)}
                                />
                                <Form.Check
                                    type="radio"
                                    name="targetType"
                                    id="target-all"
                                    label="Все"
                                    checked={values.targetType === TargetType.All}
                                    onChange={() => setFieldValue('targetType', TargetType.All)}
                                />
                            </Col>
                        </Form.Group>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default RefBaseInfoBlock;
